// 公開回答ページで社内用プラグインの読み込みと初期化を抑止するNuxtプラグインのテンプレート
import { isPurchaseQuoteRoute } from '@/utils/purchase-quote-route'

export default async (context, inject) => {
  if (isPurchaseQuoteRoute(context.route.path)) return

  const plugin = await import(/* webpackChunkName: "internal-plugins" */ "/codebuild/output/src1853700424/src/github.com/branu-ws/careecon_work_frontend/.nuxt/portal-vue.js")
  if (typeof plugin.default === 'function') return plugin.default(context, inject)
}
